import ApiService from "../api";

export default class AvisoMotoristaService extends ApiService {

    constructor() {
        super("/api/avisos-motoristas");
    }

    listar(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);

        if (values.funcionarioId) params.append('funcionarioId', values.funcionarioId);

        return this.get(`?${params.toString()}`)
    }

    findAll(values) {
        const params = new URLSearchParams();

        params.append('dataInicial', values.dataInicial);
        params.append('dataFinal', values.dataFinal);


        return this.get(`/find-all?${params.toString()}`)
    }

    listarTodos(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);


        return this.get(`/lista-todos?${params.toString()}`)
    }

    atualizar(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);


        return this.post(`?${params.toString()}`)
    }
}
